import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FadeUp, Chapter } from "@/components/Reveal";
import { FAQS } from "@/data/content";

export default function Faq() {
  return (
    <section
      data-testid="faq-section"
      className="border-t border-white/5 py-28 lg:py-36"
    >
      <div className="mx-auto max-w-3xl px-6 lg:px-10">
        <Chapter num="06" label="FAQ" center />
        <FadeUp delay={0.1}>
          <h2 className="mt-8 text-center font-serif text-4xl leading-tight tracking-[-0.02em] text-cream sm:text-5xl">
            Questions, <span className="italic text-gold">Answered.</span>
          </h2>
        </FadeUp>

        <FadeUp delay={0.2}>
          <Accordion type="single" collapsible className="mt-14">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-white/10"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="py-6 text-left font-serif text-xl text-cream transition-colors duration-300 hover:text-gold hover:no-underline [&[data-state=open]]:text-gold"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i + 1}`}
                  className="pb-6 text-sm leading-relaxed text-cream/55"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </section>
  );
}
